import TablePart from './TablePart'

export default TablePart
